import { render, staticRenderFns } from "./SolicitationTab.vue?vue&type=template&id=4bdff974&scoped=true&"
import script from "./SolicitationTab.vue?vue&type=script&lang=js&"
export * from "./SolicitationTab.vue?vue&type=script&lang=js&"
import style0 from "./SolicitationTab.vue?vue&type=style&index=0&id=4bdff974&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdff974",
  null
  
)

export default component.exports